import { render, staticRenderFns } from "./FlagNetherlands.vue?vue&type=template&id=7f6e2010&"
import script from "./FlagNetherlands.vue?vue&type=script&lang=js&"
export * from "./FlagNetherlands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports